import {Component, OnInit, ViewChild} from '@angular/core';
import {SurveyModel} from '../../../../shared/models/survey/survey.model';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {ResponseSnackbarService} from '../../../../shared/services/response-snackbar.service';
import {MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {MatCalendar} from '@angular/material/datepicker';
import {Util} from '../../../../shared/utils/Util';

@Component({
  selector: 'app-specialist-date-setter',
  templateUrl: './specialist-date-setter.component.html',
  styleUrls: ['./specialist-date-setter.component.scss']
})
export class SpecialistDateSetterComponent implements OnInit {
  loading: boolean;
  specialistData: any;
  // index: number;
  selected: Date | null;

  @ViewChild(MatCalendar, {static: false}) calendar: MatCalendar<any>;

  constructor(
    private restService: RestService,
    private dialog: MatDialogRef<SpecialistDateSetterComponent>,
    private datePipe: DatePipe,
    private responseSnackbarService: ResponseSnackbarService
  ) { }

  ngOnInit(): void {
    this.selected = new Date();
  }

  onChangeSurveyDate(){
    this.loading = true;
    if (this.selected == null) {
      this.loading = false;
      this.responseSnackbarService.onResponseMessage('Please select a date', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return;
    }
    const data = {
      assignmentId: this.specialistData.id,
      endDate: this.datePipe.transform(Util.addCurrentTimeToDate(this.selected), GeneralConstant.JPA_DATE_FORMAT)
    };

    this.restService.request<SurveyModel>(
      RequestMethod.PUT,
      ApiEndpoints.ASSIGNMENT.ASSIGNMENT,
      Actions.ASSIGNMENT.UPDATE_SPECIALIST_END_DATE,
      {body: data}
    ).subscribe(
      response => {
        this.loading = false;
        this.responseSnackbarService.onResponse(response);
        this.dialog.close(response.success ? response : null);
      });
  }
}
